import * as React from 'react';

interface Props {
  fildsetValue: string;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  placeholder: string;
  type: string;
}

const AuthFieldSet = (props: Props) => {
  return(
    <fieldset className={props.fildsetValue ? 'auth-fieldset auth-fieldset-fill' : 'auth-fieldset auth-fieldset-empty'}>
      <legend className={props.fildsetValue ? 'auth-legend' : 'auth-legend-empty'}>{props.fildsetValue ? props.placeholder : null}</legend>
      <input
        onChange={props.onChange}
        value={props.fildsetValue}
        className='auth-input'
        placeholder={props.placeholder}
        type={props.type} />
    </fieldset>
  );
};

export default AuthFieldSet;
